export default __webpack_public_path__ + "static/media/ownr_indirect_direct.988c5429.svg";